import axios from 'axios';
import qs from 'qs';

/*
 * @Author: Qzx
 * @LastEditors: Qzx
 * @Description: axios 接口请求封装
 * @Date: 2019-03-25 11:03:23
 * @LastEditTime: 2020-04-08 16:54:55
 */
let cancels = Object.create(null); // 取消接口数组
const instance = axios.create({
    timeout: 10000,
    withCredentials: true,
    headers: {
        'content-type': 'application/x-www-form-urlencoded'
    }
});
// 添加请求拦截器
instance.interceptors.request.use((config) => {
    if (config.method === 'post') {
        config.data = qs.stringify(config.data);
    }
    // 单次请求唯一性
    let cancelGroupName = config.cancelGroupName;
    if (cancelGroupName) {
        if (cancels[cancelGroupName] && cancels[cancelGroupName].cancel) {
            cancels[cancelGroupName].cancel(`${config.url} is still pending, the request has been canceled`);
        }
        config.cancelToken = new axios.CancelToken(c => {
            cancels[cancelGroupName] = { cancel: c };
        });
    }
    return config;
}, err => {
    return Promise.reject(err);
});
// 添加响应拦截器
instance.interceptors.response.use(response => {
    // 只将请求结果的data字段返回(JSON格式处理)
    let resData = response.data;
    if (typeof resData == 'string' && /{/.test(resData)) {
        resData = JSON.parse(resData);
    }
    return resData;
}, err => {
    // 对响应错误做点什么
    return Promise.reject(err);
});

export default instance;
